<template>
  <div>
    <v-autocomplete
      :search-input.sync="inputSearch"
      v-model="inputSelectProducto"
      :class="{
        closed: this.isMobile && !this.isFocused,
        'custom-autocomplete': !this.isMobile,
      }"
      @focus="isFocused = true"
      @blur="isFocused = false"
      class="expanding-search mt-1"
      prepend-inner-icon="mdi-magnify"
      rounded
      filled
      dense
      hide-no-data
      :items="productos"
      :loading="isLoading"
      @keyup.enter="eventEnter(inputSearch)"
      :placeholder="placeholderProp"
      color="blue"
      append-icon=""
      :cache-items="showSuggest"
      ref="productosApi"
      hide-details
      item-text="descripcion"
      item-value="descripcion"
      @click:clear="clearSearch()"
      clearable
      style="background-color: #3a3b3c"
    >
      <template v-slot:item="data">
        <v-list-item v-bind="data.attrs" v-on="data.on">
          <v-list-item-avatar>
            <v-icon>mdi-loading</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.descripcion }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import ProductosAPI from "@/api/productos";
export default {
  name: "producto.buscador",
  props: {
    categorias: {
      type: Array,
      required: false,
      default: () => [],
    },
    usarProductoEmpresa: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholderProp: {
      type: String,
      required: false,
      default: "Buscar",
    },
    showSuggest: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      inputSearch: "alo",
      inputSelectProducto: null,
      isLoading: false,
      productos: [],
      borrando: false, //Bandera que se activa cuando presiona 'del'
      isFocused: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  methods: {
    clearSearch() {
      console.log("Hola");

      this.inputSearch = null;
      if (this.$route.query.q || this.$route.query.barcode) {
        let query = Object.assign({}, this.$route.query);
        delete query.q;
        delete query.barcode;

        this.$router.replace({ query });
      }
    },
    focus() {
      this.$refs.productosApi.focus();
    },
    async getFromSearch(input_search) {
      try {
        this.isLoading = true;
        var replaced = input_search.split(" ").join("-");
        if (this.usarProductoEmpresa) {
          var response = await ProductosAPI.getSuggestEmpresa(
            replaced,
            this.categorias
          );
        } else {
          var response = await ProductosAPI.getSuggest(
            replaced,
            this.categorias
          );
        }

        this.productos = response.data.results;
        this.isLoading = false;
      } catch (error) {
        var e = error.response;
        this.isLoading = false;

        // this.mensajeBuscando = "No se encontró coincidencia";
      }
    },
    eventEnter(inputSearch) {
      // Quito la referencia que trae s, porque sino cuando hago reset, se borra el query parametro
      if (inputSearch == null || inputSearch == "") return;
      var search = inputSearch ? inputSearch.repeat(1) : "";

      const productMenu = this.$refs.productosApi;
      if (productMenu.isMenuActive) {
        this.$refs.productosApi.isMenuActive = false;
      }
      this.$emit("process-buscador-producto", search);
      var isBarcode = false;
      let isnum = /^\d+$/.test(search);

      if (isnum && search.length > 6) {
        isBarcode = true;
      }
      if (isBarcode) {
        this.inputSearch = "";
      }
    },
  },
  watch: {
    inputSelectProducto(val) {
      if (
        val == null ||
        val == "" ||
        val == " " ||
        val == undefined ||
        val.length < 2
      ) {
        return;
      }
      this.$emit("process-buscador-producto-select", val);
    },
    inputSearch(val) {
      //val -> lo que escribe en el buscador

      if (
        val == null ||
        val == "" ||
        val == " " ||
        val == undefined ||
        val.length < 2
      ) {
        return;
      }

      const regex = /\S|$/;
      var cantEspacios = val.search(regex) || 0;

      if (cantEspacios > 0) {
        var cadena2 = val.slice(cantEspacios);
        this.inputSearch = cadena2;
        return;
      }

      if (this.isLoading) return;
      if (this.borrando) return;

      if (this.showSuggest) {
        this.getFromSearch(val);
      } else {
        this.productos = []; // Vacía la lista si no debe sugerir
      }
    },
    "$route.query": {
      handler(value) {
        // Verificar si existe el parámetro 'q' en la URL
        const searchQuery = value.q || ""; // Si no existe, asignar ''

        if (searchQuery) {
          this.productos = [{ descripcion: searchQuery }]; // << ACÁ está el cambio
        }

        this.inputSearch = searchQuery; // Asignar el valor a inputSearch
        this.inputSelectProducto = searchQuery; // Para que v-model también lo tome (opcional)
      },
      immediate: true, // Ejecutar esto también cuando el componente se monte
    },
  },
  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.keyCode == 8) {
        this.borrando = true;
      } else {
        this.borrando = false;
      }
      if (!this.showSuggest) {
        this.productos = [];
      }
      // si presiona suprimir se borra la busqueda

      if (event.code === "Delete") {
        this.clearSearch();
      }
    });
  },
};
</script>

<style  scoped>
.v-input.custom-autocomplete {
  width: 680px;
}
.v-input.expanding-search {
  transition: max-width 0s;
}
.v-input::v-deep .v-input__control .v-input__slot {
  padding: 0 9px;
}

.v-input.expanding-search::v-deep .v-input__control.v-input__slot {
  cursor: pointer !important;
}

.v-input.expanding-search.closed {
  max-width: 40px;
}

.v-input.expanding-search.closed .v-input__slot {
  background: transparent !important;
}
</style>

